import { BORDER_RADIUS_TINY } from '@/styles';
import { createStyles } from '@/contexts/theme-context';
import { ReactNode, useRef } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import { useHover } from 'react-native-web-hooks';

interface DropDownMenuOptionProps {
  children: ReactNode;
  onSelect: () => void;
  style?: StyleProp<ViewStyle>;
}

const DropDownMenuOption: React.FC<DropDownMenuOptionProps> = ({
  onSelect,
  children,
  style,
}) => {
  const touchableOpacityRef =
    useRef<React.ComponentRef<typeof TouchableOpacity>>(null);
  const isHovered = useHover(touchableOpacityRef);
  const [styles] = useStyles();

  return (
    <TouchableOpacity
      onPress={() => {
        onSelect();
      }}
      ref={touchableOpacityRef}
      style={[
        style ? style : styles.menuOption,
        isHovered ? styles.menuOptionHover : null,
      ]}
      testID="dropdown-option"
    >
      {children}
    </TouchableOpacity>
  );
};

const useStyles = createStyles((theme) => ({
  menuOption: {
    borderRadius: BORDER_RADIUS_TINY,
  },
  menuOptionHover: {
    backgroundColor: theme.sk.color.bg.primary.hover,
    borderRadius: BORDER_RADIUS_TINY,
  },
}));

export { DropDownMenuOption };
